<ion-app>
  <ion-router-outlet></ion-router-outlet>
  <router-outlet name="modal"></router-outlet>
</ion-app>
